import React, { useState, useEffect, useRef } from 'react'
import html2canvas from 'html2canvas'

import { useStyles } from 'styles/styles'
import ContentCard from 'components/content/ContentCard'
import Feature from 'models/Feature'

interface ContentPanelProps {
    feature: Feature
}

const ContentPanel: React.FC<ContentPanelProps> = (props) => {
    const { feature } = props
    const cardRef = useRef<HTMLDivElement>(null)
    const classes = useStyles()
    const [captureName, setCaptureName] = useState<string | undefined>(undefined)

    useEffect(() => {
        if (captureName) {
            var node = cardRef.current
            if (node != null) {
                html2canvas(node, {
                    useCORS: true,
                    width: node.clientWidth,
                    height: node.clientHeight,
                    scale: 1,
                    scrollX: 0,
                    scrollY: -window.scrollY,
                })
                    .then(canvas => {
                        if (typeof (navigator.msSaveBlob) === 'function') {
                            // We are not able to save the image in Edge <= 44
                            // We can save in the Chromium based version
                            console.log("Edge")
                            // const hiddenElement = document.createElement('a')
                            // hiddenElement.href = canvas.toDataURL('image/png')
                            // hiddenElement.download = `${captureName}.png`
                            // document.body.appendChild(hiddenElement)
                            // hiddenElement.addEventListener("click", (e) => {
                            //     hiddenElement.parentNode?.removeChild(hiddenElement)
                            // })
                            // hiddenElement.click()

                            // canvas.toBlob(blob => {
                            //     navigator.msSaveBlob(blob, `${captureName}.png`)
                            // })
                        } else {
                            const hiddenElement = document.createElement('a')
                            hiddenElement.href = canvas.toDataURL('image/png')
                            hiddenElement.download = `${captureName}.png`
                            hiddenElement.click()
                        }
                        setCaptureName(undefined)
                    })
                // .catch(error => {
                //     console.log("Error", error)
                //     setCaptureName(undefined)
                // })
            } else {
                setCaptureName(undefined)
            }
        }
    }, [captureName])

    const handleDownloadImage = (name: string) => {
        setCaptureName(name)
    }

    return (
        <React.Fragment>
            <ContentCard className={classes.paragraph} feature={feature} onDownloadImage={handleDownloadImage}/>
            { captureName && 
                <ContentCard cardRef={cardRef} className={classes.cardSnapshot} feature={feature} />
            }
        </React.Fragment>
    )
}

export default ContentPanel
